exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-before-buy[data-v-8b7f65f8]{background:#fff}.content-before-buy .main-content[data-v-8b7f65f8]{width:1200px;margin:0 auto;padding-top:40px}.content-before-buy .main-content .content-free[data-v-8b7f65f8]{width:100%;height:100px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff}.content-before-buy .main-content .content-free .line[data-v-8b7f65f8]{width:100%;height:1px;background:#ebebeb}.content-before-buy .main-content .content-free .free-tip[data-v-8b7f65f8]{font-size:14px;color:#999;margin:0 8px;-ms-flex-negative:0;flex-shrink:0}", ""]);

// exports
